import React from 'react';

const TeamSection = () => {
  const founders = [
    {
      name: 'Akash Kumar Yadav',
      title: 'Founder & CEO',
      image: 'https://customer-assets.emergentagent.com/job_bloom-cycles-copy/artifacts/4gp5h7j4_image.png',
      description: 'Leading BLOOMCYCLE INNOVATIONS\'s mission to transform agriculture into climate solutions'
    },
    {
      name: 'Prabhjot Singh Shergill',
      title: 'CTO - Growth & Strategy',
      image: 'https://customer-assets.emergentagent.com/job_bloom-cycles-copy/artifacts/uq31rj9v_Prabhjot.jpg',
      description: 'Driving technological innovation and strategic growth initiatives'
    },
    {
      name: 'Abhijit Nair',
      title: 'Board Member - Head of Innovation & Collaborations',
      image: 'https://customer-assets.emergentagent.com/job_bloom-cycles-copy/artifacts/z9dpg4m1_abhijit.jpg',
      description: 'Spearheading innovation and strategic partnerships'
    }
  ];

  return (
    <section id="team" className="pt-0 pb-10 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16 pt-20">
          <h2 className="text-4xl font-heading font-bold text-neo-black mb-4">Our Leadership - Built to Execute</h2>
          <p className="text-xl text-neo-gray max-w-3xl mx-auto font-body">
            Our seasoned leadership combines industrial expertise with grassroots deployment. We are uniquely positioned to build India's leading carbon farming network.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-0">
          {founders.map((founder, index) => (
            <div 
              key={index}
              className="bg-gray-50 border-2 border-neo-emerald/20 rounded-2xl overflow-hidden hover:border-neo-emerald/40 hover:shadow-xl hover:shadow-neo-emerald/20 transition-all duration-300"
            >
              <div className="aspect-square overflow-hidden bg-gray-50">
                <img 
                  src={founder.image}
                  alt={founder.name}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-heading font-bold text-neo-black mb-1">{founder.name}</h3>
                <p className="text-neo-emerald font-semibold mb-3 font-body">{founder.title}</p>
                <p className="text-sm text-neo-gray font-body">{founder.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-neo-emerald/10 to-neo-emerald/5 border border-neo-emerald/20 rounded-2xl p-8">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-heading font-bold text-neo-black mb-2">Guided by Industry Experts</h3>
            <p className="text-neo-gray font-body">
              Our advisory board comprises top-level mentors with decades of experience in agriculture, sustainability, and climate technology, guiding our strategic vision and execution.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-gray-50 border border-neo-emerald/20 rounded-xl p-6 text-center shadow-sm">
              <div className="w-16 h-16 bg-neo-emerald/20 rounded-full mx-auto mb-3 flex items-center justify-center">
                <span className="text-2xl font-heading font-bold text-neo-emerald">A+</span>
              </div>
              <p className="text-sm font-semibold text-neo-black font-body">Agriculture Industry Veterans</p>
              <p className="text-xs text-neo-gray mt-1 font-body">40+ years combined experience</p>
            </div>
            <div className="bg-gray-50 border border-neo-emerald/20 rounded-xl p-6 text-center shadow-sm">
              <div className="w-16 h-16 bg-neo-emerald/20 rounded-full mx-auto mb-3 flex items-center justify-center">
                <span className="text-2xl font-heading font-bold text-neo-emerald">C+</span>
              </div>
              <p className="text-sm font-semibold text-neo-white font-body">Climate Tech Experts</p>
              <p className="text-xs text-neo-gray mt-1 font-body">Leading carbon credit programs</p>
            </div>
            <div className="bg-gray-50 border border-neo-emerald/20 rounded-xl p-6 text-center shadow-sm">
              <div className="w-16 h-16 bg-neo-emerald/20 rounded-full mx-auto mb-3 flex items-center justify-center">
                <span className="text-2xl font-heading font-bold text-neo-emerald">B+</span>
              </div>
              <p className="text-sm font-semibold text-neo-white font-body">Business Strategy Leaders</p>
              <p className="text-xs text-neo-gray mt-1 font-body">Scaling ventures to $100M+</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
